"use client";

import { getStoryblokApi } from "../lib/storyblok";

export function StoryblokProvider({ children }: { children: React.ReactNode }) {
  getStoryblokApi();
  return children;
}
